import { Check } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useT } from "../i18n/useT";

export default function Problems() {
  const t = useT();
  return (
    <section id="problems" className="py-24 sm:py-28 border-t border-ink-800/60 bg-ink-900/30">
      <div className="container-page">
        <SectionHeading eyebrow={t.problems.eyebrow} title={t.problems.title} lede={t.problems.lede} />
        <ul className="mt-12 grid gap-3 sm:grid-cols-2">
          {t.problems.items.map((p) => (
            <li
              key={p}
              className="flex items-start gap-3 rounded-lg border border-ink-800 bg-ink-900/50 p-4"
            >
              <Check className="mt-0.5 size-4 shrink-0 text-accent-500" />
              <span className="text-sm text-ink-200 leading-relaxed">{p}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
